<template>
  <div class="home-sector" :class="{ last: isLast, first: isFirst }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.home-sector {
  margin-top: 15px;
  margin-bottom: 15px;
}
.home-sector.first {
  margin-top: 0;
}
.home-sector.last {
  margin-bottom: 0;
}
</style>
